import React, { Component } from 'react';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import GithubRepoCard from '../../components/githubRepoCard/GithubRepoCard';
import Button from "../../components/button/Button";
import {Fade} from 'react-reveal';
import {talksHeader} from '../../portfolio.js';
import TalksData from '../../shared/talks.json';
import './talks.css';
import TalksImg from "./TalksImg";


class Talks extends Component {
    render(){
		const theme = this.props.theme;
        return (
					<div className="talks-main">
						<Header theme={theme} />
						<div className="online-talks">
							<Fade bottom duration={2000} distance="40px">
								<div className="talks-heading-div">
									<div className="talks-heading-img-div">
										{ <img
											src={require(`../../assests/images/${talksHeader["avatar_image_path"]}`)}
											alt=""
										/> }
										{/*<TalksImg theme={theme} />*/}
									</div>
									<div className="talks-heading-text-div">
										<h1 className="talks-heading-text" style={{ color: theme.text }}>
											{talksHeader.title}
										</h1>
										<p className="talks-header-detail-text subTitle" style={{ color: theme.secondaryText }}>
											{talksHeader["description"]}
										</p>
									</div>
								</div>
							</Fade>
						</div>
						<div className="repo-cards-div-main">
							{TalksData.data.map((repo) => {
								return <GithubRepoCard repo={repo} theme={theme} />;
							})}
						</div>
						<Button
							text={"More Talks"}
							className="talks-button"
							href="https://github.com/murari-goswami"
							newTab={true}
							theme={theme}
						/>
						<Footer theme={this.props.theme} onToggle={this.props.onToggle} />
					</div>
				);
    }
}

export default Talks;